export default "__VITE_ASSET__BgMQFKql__"